export default __webpack_public_path__ + "static/media/rio_gallegos.58446e8a.jpg";